<script>
  import Portfolio from "../pages/Portfolio.svelte";
  import { scroll } from "../store/parallax";
  import Saos from "saos";
  import Resume from "./Resume.svelte";
  import About from "./About.svelte";
  import Footer from "../components/footer.svelte";
</script>

<main>
  <section>
    <div class="max-w-screen min-h-[calc(100vh-4.5rem)] flex items-center">
      <div class="md:px-10 pl-4 max-w-screen">
        <Saos
          animation={"focus-in-contract 2s cubic-bezier(0.35, 0.5, 0.65, 0.95) both"}
        >
          <h1 class="uppercase xl:text-9xl lg:text-8xl md:text-6xl text-4xl font-thin">Interdisciplinary</h1>
          <p class="uppercase 2xl:text-9xl xl:text-8xl lg:text-7xl md:text-5xl text-[2rem] font-semibold">Frontend Developer</p>
        </Saos>
        <div class="lg:w-1/3 md:w-2/3 py-4 md:px-2 pr-6">
          <Saos
            animation={"tracking-in-expand 2s cubic-bezier(0.35, 0.5, 0.65, 0.95) 1s both"}
          >
            <p class='md:text-lg text-sm'>
              Hey There! I'm Azar M, a web developer with an affinity to work on
              modern web designs. I build medium to large scale websites which
              are SEO Friendly and with high security and performance.
            </p>
          </Saos>
        </div>
      </div>
    </div>
  </section>
  <section class="py-8">
    <Portfolio />
  </section>
  <section class="py-8">
    <Resume />
  </section>
  <section class="py-8">
    <About />
  </section>
  <section class="pt-8" />
</main>
